//
// Spinning loading icon.
//
export const Loading = () => {
  return pug`
    .w-full.col.center.py-2
      Icon.h-6.text-gray-400.animate.animate-spin(icon='circle-notch')
  `
}
